/**
 * WhatsApp Integration Utilities
 * Mobile-first WhatsApp integration for cart sharing and support
 */

/**
 * Generate WhatsApp deep link for cart sharing
 * @param {Array} cartItems - Array of cart items
 * @param {number} total - Total amount
 * @returns {string} WhatsApp URL
 */
export const shareCartViaWhatsApp = (cartItems, total) => {
  const cartText = cartItems
    .map((item, index) => {
      return `${index + 1}. ${item.title} x${item.quantity} - ₹${item.price * item.quantity}`;
    })
    .join('\n');

  const message = `🛒 *My Mothering Cart*\n\n${cartText}\n\n*Total: ₹${total}*\n\n🔗 Shop at: ${window.location.origin}`;
  
  const encodedMessage = encodeURIComponent(message);
  return `https://wa.me/?text=${encodedMessage}`;
};

/**
 * Open WhatsApp chat with support
 * @param {string} phoneNumber - Support phone number (with country code)
 * @param {string} message - Pre-filled message (optional)
 * @returns {string} WhatsApp URL
 */
export const openWhatsAppSupport = (phoneNumber = '918810345965', message = '') => {
  const defaultMessage = message || 'Hi! I need help with my order on Mothering.';
  const encodedMessage = encodeURIComponent(defaultMessage);
  return `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
};

/**
 * Share product via WhatsApp
 * @param {Object} product - Product object
 * @returns {string} WhatsApp URL
 */
export const shareProductViaWhatsApp = (product) => {
  const message = `✨ Check out this product on Mothering!\n\n*${product.title}*\n\n💰 Price: ₹${product.price}\n${product.original_price ? `~~₹${product.original_price}~~\n` : ''}\n🔗 ${window.location.origin}/products/${product.id}`;
  
  const encodedMessage = encodeURIComponent(message);
  return `https://wa.me/?text=${encodedMessage}`;
};

/**
 * Share order confirmation via WhatsApp
 * @param {string} orderId - Order ID
 * @param {number} total - Order total
 * @returns {string} WhatsApp URL
 */
export const shareOrderViaWhatsApp = (orderId, total) => {
  const message = `🎉 *Order Placed Successfully!*\n\nOrder ID: ${orderId}\nTotal: ₹${total}\n\nTrack your order at: ${window.location.origin}/orders`;
  
  const encodedMessage = encodeURIComponent(message);
  return `https://wa.me/?text=${encodedMessage}`;
};

/**
 * Open WhatsApp with a custom message
 * @param {string} message - Custom message
 * @param {string} phoneNumber - Phone number (optional, for direct chat)
 * @returns {string} WhatsApp URL
 */
export const openWhatsApp = (message, phoneNumber = null) => {
  const encodedMessage = encodeURIComponent(message);
  if (phoneNumber) {
    return `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
  }
  return `https://wa.me/?text=${encodedMessage}`;
};
